// UI strings for the Lausepino sentences the AI check passed (stack_sentence status 'checked',
// written only by `npm run stack:ai-apply`): their list, the count under the deck, and the neutral
// source words the translator uses for them. Axel 2026-10-22: no AI or status mark is shown on them
// (no "AI-tarkistettu" / "AI-korjattu"); they are our translations, still open to approve, fix or skip.
// Never presented as the users' approval. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const stackCheckedFi = {
  /** The list of these sentences (/sentence-stack/checked) and its link under the deck. */
  tab: 'Hyväksymättä',
  empty: 'Kaikki lauseet on käyty läpi.',
  /** After "N jäljellä · helpoimmat ensin" on the progress line. */
  left: (n: number, shown: string) => (n === 1 ? '1 odottaa hyväksyntää' : `${shown} odottaa hyväksyntää`),
  /** A part of a partial translation taken from such a sentence (never "hyväksytty"). */
  partialFrom: 'Lausepinosta',
  partialBuilt: 'rakennettu Lausepinon lauseen pohjalta',
  partialHow: 'Merkityt osat ovat Lausepinon käännöksiä. Muut osat kääntäjä teki sääntöjensä avulla.',
  /** Before the HV a fix replaced (the check results shown are that suggestion's). */
  originalHv: 'Alkuperäinen ehdotus',
  /** A user decided the Finnish of such a sentence. */
  fiBy: (name: string) => `Suomennoksen hyväksynyt: ${name}`,
};

export type StackCheckedMessages = typeof stackCheckedFi;

export const stackCheckedEn: StackCheckedMessages = {
  tab: 'Not approved',
  empty: 'All sentences have been gone through.',
  left: (_n, shown) => `${shown} waiting for approval`,
  partialFrom: 'from Lausepino',
  partialBuilt: 'built on a Lausepino sentence',
  partialHow: 'The marked parts are Lausepino translations. The translator made the other parts with its rules.',
  originalHv: 'Original suggestion',
  fiBy: (name) => `Finnish approved by ${name}`,
};

// Messages.stackChecked (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('stackChecked', stackCheckedFi, stackCheckedEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof stackCheckedFi> {}
}
